import React, { useEffect, useState } from "react";
import ScheduleLayout from "../Components/ScheduleLayout";
import TaskHeader from "./TaskHeader";
import { Dropdown, message } from "antd";

import {
  AddApprovers,
  DueDate,
  LabelSelect,
  ParentTaskSelect,
  PhaseSelect,
  PrioritySelect,
  RowLayout,
  ScheduleCollaboratorSelect,
  SelectStatus,
  SprintSelect,
  TaskDueDate,
  TaskInput,
  UserSelect,
  VersionSelect,
} from "./TaskReusable";
import TimeInput from "./TimeInput";

import CommentsAndActivity from "./CommentsAndActivity";
import InfoByFrosty from "../../../Core/CommonV2/InfoByFrosty";
import NewLabelModal from "../Modals/NewLabelModal";
import { useAppDispatch, useAppSelector } from "../../../Core/redux/hooks";
import {
  resetSchedule,
  updateSchedule,
} from "../../../Core/redux/slices/schedule.slice";
import ManageLabelsModal from "../Modals/ManageLabelsModal";
import DeleteLabelModal from "../Modals/DeleteLabelModal";
import NewReleaseVersionModal from "../Modals/NewReleaseVersionModal";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  createGoal,
  getGoalDetails,
  getGoalsBySprint,
  getLabels,
  getReleaseVersions,
  getSprintsByPhase,
  getSubtaskDetails,
  getTaskActivityLog,
  getTodoList,
  updateGoal,
  updateParentTaskTimeLog,
  updateProgress,
} from "../../../Core/redux/api/scheduleAPI";
import AttachmentsAndSubtask from "./AttachmentsAndSubtask";
import { client } from "../../../Core/utils/axiosClient";
import { getComments } from "../../../Core/redux/api/conversationAPI";
import {
  DEFAULT_LIMIT,
  TASK_ACTIVITY_LOG_ACTIONS,
} from "../../../Core/constants";
import usePermission from "../../../Core/hooks/usePermission";
import { DotsVerticalIcon } from "../../../Core/svgV2/DotsVertical";
import { CopyIcon, CopyLinkIcon } from "../../../Core/svgV2/CopyIcon";
import { DeleteIcon } from "../../../Core/svgV2/DeleteIcon";
import copyTextToClipboard from "../../../Core/utils/clipboard";
import DeleteTaskModal from "../Modals/DeleteTaskModal";

import FilePreviweModal from "../../Conversations/Modals/FIlePreviweModal";
import { resetConversations } from "../../../Core/redux/slices/conversations.slice";
import { updateDashboard } from "../../../Core/redux/slices/dashboard.slice";
import { useQueryClient } from "react-query";
import dayjs from "dayjs";
import MyBoardLabel from "../../../Core/CommonV3/MyBoardLabel";
import { useGetProjectList } from "../../../Core/redux/ReactQueryHooksV3/useProjectAPI";
import DiscardEditedGoalModal from "./DiscardEditedGoalModal";

const ScheduleSubtaskScreen = () => {
  const { user } = useAppSelector((state) => state.userDetails);
  const { projectId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { filePreview } = useAppSelector((state) => state.conversations);
  const [discardModal, setDiscardModal] = useState(false);

  const { automations } = useAppSelector((state) => state.settings);
  const [taskDeleteModal, setTaskDeleteModal] = useState(false);
  const [completedOn, setCompletedOn] = useState("");

  const navigate = useNavigate();
  const {
    newLabelModal,
    manageLabelModal,
    deleteLabelModal,
    newReleaseVersionModal,
    selectedTask,
    phases,
    sprints,
    newTask,
    selectedTasks,
    collaboratorsForTask,
    taskActivity,
    swimlanes,
    goals,
    todoList,
  } = useAppSelector((state) => state.schedule);
  const dispatch = useAppDispatch();
  const { taskId, subtaskId } = useParams();

  const [taskType, setTaskType] = useState(4);
  const [isWaddleIt, setIsWaddleIt] = useState(false);
  const [parentTaskTime, setParentTaskTime] = useState("");
  const originalParentGoal =
    goals?.find((l) => +l.id == +taskId) ||
    todoList?.find((l) => +l.id === +taskId);
  const [parentGoal, setParentGoal] = useState(originalParentGoal);
  const queryClient: any = useQueryClient();

  const { data: projectList, isLoading: isLoadingProjectList } =
    useGetProjectList(user.id);

  const getName = () => {
    switch (selectedTask?.goalType) {
      case "1":
        return "task";
      case "3":
        return "bug";
      default:
        return "task";
    }
  };

  useEffect(() => {
    dispatch(getLabels({ projectId, isMyBoard: false }));
    dispatch(getReleaseVersions({ projectId }));
    dispatch(getSprintsByPhase({ projectId }));
  }, [projectId]);

  useEffect(() => {
    if (subtaskId !== "new") {
      if (+subtaskId !== +selectedTask?.id) {
        dispatch(getSubtaskDetails({ goalId: subtaskId }));
      }
      dispatch(
        getComments({
          docId: subtaskId,
          docType: "task",
          limit: 1000,
          offset: 0,
        })
      );
      dispatch(getTaskActivityLog({ goalId: subtaskId }));
      dispatch(updateSchedule({ key: "isTaskExpanded", value: true }));
    }
  }, [subtaskId]);

  const updateSprintGoals = (taskDetails) => {
    if (taskDetails.sprintId) {
      dispatch(
        getGoalsBySprint({
          projectId,
          sprintId: taskDetails.sprintId,
          module: "sprints",
        })
      );
    } else {
      dispatch(getTodoList({ projectId }));
    }
  };

  const sprintIdFromSearchParams =
    searchParams.get("sprintId") == "null"
      ? null
      : searchParams.get("sprintId");

  const [taskDetails, setTaskDetails] = useState({
    statusId: 1,
    createdAt: null,
    name: "",
    id: "",

    swminlaneId: "",
    assigneeId: user.id,
    parentGoalId: taskId,

    priorityId: 1,
    estimatedTime: "",
    releaseVersionId: "",
    description: "",
    timeLogged: "",
    attachments: [],
    dueDate: null,

    sprintId: sprintIdFromSearchParams || null,
  });
  const [editedTaskDetails, setEditedTaskDetails] = useState(null);

  const [timeoutId, setTimeoutId] = useState(null);

  const { formState, control, setValue, handleSubmit, getValues } = useForm({
    values: {
      taskName: "",
      timeLogged: "",
    },
  });
  const [editTaskName, setEditTaskName] = useState(selectedTask?.name);

  useEffect(() => {
    if (subtaskId !== "new" && selectedTask) {
      setValue("taskName", selectedTask?.name);
      setEditTaskName(selectedTask?.name);

      setTaskDetails({
        ...selectedTask,
        attachments: selectedTask?.attachments
          ? JSON.parse(selectedTask?.attachments)
          : [],
      });

      setIsWaddleIt(false);
      setTaskType(4);
      const swimlaneId = swimlanes.filter((item) => item.statusId == 3);

      if (
        taskActivity &&
        taskActivity.length > 0 &&
        taskActivity[0].newValue == swimlaneId[0].id &&
        taskActivity[0].action == "STATUS_CHANGED"
      ) {
        if (selectedTask.id == taskActivity[0].goalId)
          setCompletedOn(dayjs(taskActivity[0].timestamp).format("DD/MM/YYYY"));
      }
    }
  }, [selectedTask]);

  useEffect(() => {
    if (newTask) {
      setValue("taskName", newTask.name);
      setValue("timeLogged", newTask.timeLogged);
      setTaskDetails({
        ...taskDetails,
        sprintId: newTask?.sprintId ? newTask?.sprintId : null,
      });
      // setTaskType(newTask.goalType);
    }
  }, [newTask]);

  const createTask = async (data) => {
    const uniqueCollaboratorIds = [];
    collaboratorsForTask.forEach((element) => {
      if (!uniqueCollaboratorIds.includes(element)) {
        uniqueCollaboratorIds.push(element);
      }
    });
    const payload = {
      sprintId: taskDetails.sprintId,
      projectId: projectId,
      parentGoalId: taskDetails.parentGoalId,
      name: data.taskName,
      isCompleted: 0,
      isNewGoal: Number(taskType === 4),
      statusId: taskDetails.statusId,
      swimlaneId: taskDetails.swminlaneId,
      priorityId: taskDetails.priorityId,
      goalType: 4,
      assigneeId: taskDetails.assigneeId,
      description: taskDetails.description,
      estimatedTime: taskDetails.estimatedTime,
      timeLogged: taskDetails.timeLogged
        ? taskDetails.timeLogged
        : data.timeLoggged
        ? data.timeLogged
        : "",
      attachments: JSON.stringify(taskDetails.attachments),
      releaseVersionId: taskDetails.releaseVersionId,
      dueDate: taskDetails.dueDate,
      isWaddleIt,
      collaborators: collaboratorsForTask ? uniqueCollaboratorIds : [],
    };
    const getNewGoalName = () => {
      switch (taskType) {
        case 1:
          return "task";
        case 3:
          return "bug";
        case 4:
          return "subtask";
        default:
          return "task";
      }
    };
    // console.log(payload, "payload");
    const response = await dispatch(createGoal(payload));
    const sprintId = taskDetails.sprintId;
    if (sprintId) {
      await dispatch(
        getGoalsBySprint({
          projectId,
          sprintId,
          module: "sprints",
        })
      );
    } else {
      await dispatch(
        getTodoList({ projectId, limit: DEFAULT_LIMIT, offset: 0 })
      );
    }
    dispatch(
      updateSchedule({
        key: "newTask",
        value: { goalType: "", name: "" },
      })
    );
    dispatch(
      updateDashboard({
        key: "alertPopupModal",
        value: {
          visible: true,
          data: {
            title: `New ${getNewGoalName()} created`,
            subtitle: `${data.taskName}`,
            description: "",
          },
        },
      })
    );
    dispatch(updateSchedule({ key: "selectedTask", value: payload }));

    const selectedSprint = sprints?.find(
      (sprint) => +taskDetails?.sprintId == sprint.id
    );

    if (subtaskId !== "new") {
      navigate(
        `/schedule/${projectId}/sprints/${searchParams.get("sprintId")}`
      );
    } else {
      dispatch(
        updateSchedule({
          key: "collaboratorsForTask",
          value: [],
        })
      );
      taskDetails?.sprintId
        ? selectedSprint?.status == 2
          ? navigate(`/schedule/${projectId}/sprints/${taskDetails.sprintId}`)
          : navigate(`/schedule/${projectId}/sprints`)
        : navigate(-1);
    }

    dispatch(
      updateProgress({
        projectId,
      })
    );
  };
  const handleClose = async () => {
    const currentUrl = localStorage.getItem("taskRedirectUrl");
    dispatch(updateSchedule({ key: "isTaskExpanded", value: false }));
    // console.log(currentUrl, "currentUrl here");
    if (parentGoal?.sprintId) {
      await queryClient.invalidateQueries([
        "goalsBySprint",
        projectId,
        +parentGoal.sprintId,
      ]);
    } else {
      await dispatch(
        getGoalsBySprint({
          projectId,
          module: "backlog",
        })
      );
    }

    // navigate(-1);
    let redirectToLink = "";
    if (projectList?.length > 0) {
      const project = projectList?.find(
        (project) => +project.id === +projectId
      );
      redirectToLink = `/schedule/${project?.id}/sprints/${parentGoal?.sprintId}`;
    }

    subtaskId === "new"
      ? navigate(-1)
      : parentGoal?.sprintId
      ? redirectToLink
        ? navigate(redirectToLink)
        : navigate(-1)
      : navigate(`/schedule/${projectId}/backlog`);
    console.log(currentUrl, "im here2", redirectToLink);
  };
  const editTask = async () => {
    const action = [];
    if (editedTaskDetails.assigneeId) {
      action.push({
        oldValue: selectedTask.assigneeId,
        newValue: editedTaskDetails.assigneeId,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.ASSIGNEE_CHANGED,
      });
    }
    if (editedTaskDetails.reporterId) {
      action.push({
        oldValue: selectedTask.reporterId,
        newValue: editedTaskDetails.reporterId,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.REPORTER_CHANGED,
      });
    }
    if (editedTaskDetails.statusId || editedTaskDetails.swimlaneId) {
      action.push({
        oldValue: selectedTask.swimlaneId,
        newValue: editedTaskDetails.swimlaneId,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.STATUS_CHANGED,
      });
    }
    if (editedTaskDetails.phaseId) {
      action.push({
        oldValue: selectedTask.phaseId,
        newValue: editedTaskDetails.phaseId,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.PHASE_CHANGED,
      });
    }
    if (editedTaskDetails.priorityId) {
      action.push({
        oldValue: selectedTask.priorityId,
        newValue: editedTaskDetails.priorityId,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.PRIORITY_CHANGE,
      });
    }
    if (editedTaskDetails.labelId) {
      action.push({
        oldValue: selectedTask.labelId,
        newValue: editedTaskDetails.labelId,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.LABEL_CHANGE,
      });
    }
    if (editedTaskDetails.sprintId) {
      action.push({
        oldValue: selectedTask.sprintId,
        newValue: editedTaskDetails.sprintId,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.SPRINT_CHANGE,
      });
    }
    if (editedTaskDetails.estimatedTime) {
      action.push({
        oldValue: selectedTask.estimatedTime,
        newValue: editedTaskDetails.estimatedTime,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.ESTIMATE_CHANGE,
      });
    }
    if (editedTaskDetails.timeLogged) {
      action.push({
        oldValue: selectedTask.timeLogged,
        newValue: editedTaskDetails.timeLogged,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.TIMELOG_CHANGE,
      });
      if (selectedTask?.parentGoalId) {
        // Dispatch the async thunk to update the parent task's time log
        const payload = {
          parentGoalId: selectedTask.parentGoalId,
          minutesToAdd: parentTaskTime,
        };
        dispatch(updateParentTaskTimeLog(payload));
      }
    }
    if (editedTaskDetails.releaseVersionId) {
      action.push({
        oldValue: selectedTask.releaseVersionId,
        newValue: editedTaskDetails.releaseVersionId,
        actionName: TASK_ACTIVITY_LOG_ACTIONS.RELEASE_VERSION_CHANGE,
      });
    }
    const payload = {
      ...editedTaskDetails,
      action: [...action],
      goalId: subtaskId,
    };
    await dispatch(updateGoal(payload));
    dispatch(getSubtaskDetails({ goalId: subtaskId }));
    dispatch(getTaskActivityLog({ goalId: subtaskId }));
    if (editedTaskDetails.assigneeId) {
      await client.post("/notifications/create", {
        notificationType: "32",
        goalId: subtaskId,
        allUsers: [{ userId: taskDetails.assigneeId }],
        projectId,
        meta: {
          oldAssigneeId: selectedTask.assigneeId,
          newAssigneeId: editedTaskDetails.assigneeId,
        },
      });
    }
    if (editedTaskDetails.statusId && editedTaskDetails.statusId == 3) {
      dispatch(
        updateProgress({
          projectId,
        })
      );
    }
    // setTaskDetails({ ...taskDetails, ...editedTaskDetails });
    updateSprintGoals(taskDetails);
    setEditedTaskDetails(null);
    if (subtaskId !== "new") {
      handleClose();
    } else {
      dispatch(updateSchedule({ key: "isTaskExpanded", value: false }));
    }
  };
  const onSubmit = async (data) => {
    if (subtaskId === "new") {
      createTask(data);
    } else {
      editTask();
    }
  };
  const { hasPermission: TASK_EVENT_SCOPE_DELETE } = usePermission("10");

  const groupItems = [
    {
      key: "1",
      label: <div className="out-300-14 text-gray-700">Copy link</div>,
      icon: <CopyLinkIcon />,
    },

    {
      key: "2",
      label: (
        <div className="out-300-14 leading-5 text-gray-700">Duplicate</div>
      ),
      icon: <CopyIcon className="text-gray-700" />,
    },

    TASK_EVENT_SCOPE_DELETE ? { key: "divider", type: "divider" } : null,
    TASK_EVENT_SCOPE_DELETE
      ? {
          key: "3",
          label: <div className="out-300-14 text-gray-700">Delete</div>,

          icon: <DeleteIcon className="text-gray-700 " />,
        }
      : null,
  ];

  // automation code
  useEffect(() => {
    if (subtaskId === "new") {
      const getReporterAutomations = automations.find(
        (a) => a.goalType == taskType && a.fieldName === "Reporter"
      );
      if (getReporterAutomations && getReporterAutomations.value) {
        setTaskDetails((prev) => {
          const obj = { ...prev, reporterId: getReporterAutomations.value };
          return obj;
        });
      } else {
        setTaskDetails((prev) => {
          const obj = { ...prev, reporterId: null };
          return obj;
        });
      }
      if (getValues("timeLogged")) {
        setTaskDetails((prev) => {
          const obj = { ...prev, timeLogged: getValues("timeLogged") };
          return obj;
        });
      }
      const getAssigneerAutomations = automations.find(
        (a) => a.goalType == taskType && a.fieldName === "Assignee"
      );
      if (getAssigneerAutomations && getAssigneerAutomations.value) {
        setTaskDetails((prev) => {
          const obj = { ...prev, assigneeId: getAssigneerAutomations.value };
          return obj;
        });
      } else {
        setTaskDetails((prev) => {
          const obj = { ...prev, assigneeId: user.id };
          return obj;
        });
      }
    }
  }, [taskType, subtaskId]);

  const { hasPermission: TASK_EVENT_SCOPE_EDIT } = usePermission("9");
  const { hasPermission: REPORTER_EDIT } = usePermission("20");
  const { hasPermission: LOG_TIME_EDIT } = usePermission("18");
  const { hasPermission: LOG_TIME_ADD } = usePermission("17");

  const hasEditAccess = TASK_EVENT_SCOPE_EDIT || taskId === "new";

  const handleDuplicate = async () => {
    try {
      const { data } = await client.post("/schedule/duplicate-goal", {
        id: subtaskId,
      });

      navigate(
        `/schedule/${projectId}/task/${taskId}/subtask/${data.result.id}`
      );
    } catch (e) {
      console.log(e);
    }
  };

  const onDiscardTask = async () => {
    await dispatch(updateSchedule({ key: "isGoalEdited", value: false }));
    handleClose();
  };

  const onClick = ({ key }) => {
    switch (key) {
      case "1":
        copyTextToClipboard(window.location.href);
        break;
      case "2":
        handleDuplicate();
        break;
      case "3":
        dispatch(
          updateSchedule({
            key: "selectedTasks",
            value: subtaskId ? [subtaskId] : [taskId],
          })
        );

        setTaskDeleteModal(true);
        break;
      default:
        break;
    }
  };
  return (
    <ScheduleLayout>
      <TaskHeader
        taskType={taskType}
        isWaddleIt={false}
        setIsWaddleIt={() => console.log("")}
        setTaskType={setTaskType}
        handleSubmit={handleSubmit(onSubmit)}
        task={taskDetails}
        editedTaskDetails={editedTaskDetails}
        onCancel={() => {
          if (
            editedTaskDetails &&
            Object.keys(editedTaskDetails).length !== 0
          ) {
            setDiscardModal(true);
          } else {
            handleClose();
          }
        }}
        isEdited={
          !!editedTaskDetails && Object.keys(editedTaskDetails).length !== 0
        }
      />
      <div className="flex bg-white min-h-[calc(100vh-100px)]">
        <div className="flex-1 px-6 py-4 min-h-[calc(100vh-100px)] max-h-[calc(100vh-100px)] overflow-y-auto">
          {subtaskId === "new" ? (
            <Controller
              name="taskName"
              control={control}
              rules={{ required: "Please enter a title before submitting" }}
              render={({ field, formState }) => (
                <TaskInput
                  {...field}
                  autoSize
                  placeholder="Enter a title"
                  showError={formState.errors.taskName?.message ? true : false}
                />
              )}
            />
          ) : (
            <TaskInput
              autoSize
              value={editTaskName}
              placeholder="Enter a title"
              onChange={async (e) => {
                // setTaskDetails({ ...taskDetails, name: e.target.value });
                if (
                  !(
                    TASK_EVENT_SCOPE_EDIT ||
                    parentGoal?.collaborators.includes(user.id)
                  )
                )
                  return;
                setEditTaskName(e.target.value);
                clearTimeout(timeoutId);

                setEditedTaskDetails({
                  ...editedTaskDetails,
                  name: e.target.value,
                });

                setTimeoutId(
                  setTimeout(() => {
                    dispatch(
                      updateSchedule({ key: "isGoalEdited", value: true })
                    );
                    // dispatch(
                    //   updateGoal({
                    //     name: e.target.value,
                    //     goalId: selectedTask.id,
                    //   })
                    // );
                  }, 1000)
                );
              }}
              showError={formState.errors.taskName?.message ? true : false}
            />
          )}

          {formState.errors.taskName?.message && (
            <div className="mt-1.5 out-300-12 text-left text-error-500">
              {formState.errors.taskName?.message}
            </div>
          )}

          <div className="mt-4  ">
            <TaskInput
              onChange={async (e) => {
                if (
                  !(
                    hasEditAccess || parentGoal?.collaborators.includes(user.id)
                  )
                )
                  return;
                setTaskDetails({ ...taskDetails, description: e.target.value });
                if (subtaskId !== "new") {
                  setEditedTaskDetails({
                    ...editedTaskDetails,
                    description: e.target.value,
                  });
                  // await dispatch(
                  //   updateGoal({
                  //     description: e.target.value,
                  //     goalId: selectedTask.id,
                  //   })
                  // );
                  await dispatch(
                    updateSchedule({ key: "isGoalEdited", value: true })
                  );
                }
              }}
              autoSize={{ minRows: 3 }}
              inputClassName="task-description"
              placeholder="Enter a description..."
              value={taskDetails.description}
            />
          </div>
          <AttachmentsAndSubtask
            task={taskDetails}
            setSubtasks={async (e) => {
              setTaskDetails(e);
              // setEditedTaskDetails({
              //   ...editedTaskDetails,
              //   subtasks: e.subtasks,
              // });
            }}
            setEditedSubtaskDetails={(e) => {
              setEditedTaskDetails({
                ...editedTaskDetails,
                subtasks: e.subtasks,
              });
            }}
            setAttachments={async (e) => {
              setTaskDetails(e);
              setEditedTaskDetails({
                ...editedTaskDetails,
                attachments: e.attachments,
              });
            }}
            setEditedAttachmentDetails={(e) => {
              setEditedTaskDetails({
                ...editedTaskDetails,
                attachments: e.attachments,
              });
            }}
          />

          {subtaskId !== "new" && <CommentsAndActivity task={selectedTask} />}
        </div>
        <div className="px-6 w-[386px] border-l border-gray-200 min-h-[calc(100vh-100px)] max-h-[calc(100vh-100px)] overflow-y-auto pt-5 ">
          <div className="flex justify-between">
            <SelectStatus
              setStatusId={async (e) => {
                if (
                  !(
                    hasEditAccess || parentGoal?.collaborators.includes(user.id)
                  )
                )
                  return;

                if (taskDetails.sprintId) {
                  const currentSprint = sprints.find(
                    (sprint) => +sprint.id == +taskDetails.sprintId
                  );

                  if (currentSprint && currentSprint.status == 3) {
                    message.error({
                      content: (
                        <span className="out-400-14 text-gray-900 cursor-pointer">
                          Please Start the Sprint first!
                        </span>
                      ),
                      className: "custom-message",
                      style: {
                        borderRadius: "10px",
                      },
                    });

                    return;
                  }
                  if (currentSprint && currentSprint.status < 2) {
                    message.error({
                      content: (
                        <span className="out-400-14 text-gray-900 cursor-pointer">
                          Please Start the Sprint first!
                        </span>
                      ),
                      className: "custom-message",
                      style: {
                        borderRadius: "10px",
                      },
                    });

                    return;
                  }
                }

                setTaskDetails((oldState) => {
                  const newState = {
                    ...oldState,
                    statusId: e.statusId,
                    swimlaneId: e.swimlaneId,
                  };
                  return newState;
                });
                if (subtaskId !== "new") {
                  setEditedTaskDetails({
                    ...editedTaskDetails,
                    statusId: e.statusId,
                    swimlaneId: e.swimlaneId,
                  });
                  // await dispatch(
                  //   updateGoal({
                  //     ...e,
                  //     goalId: subtaskId,
                  //     action: {
                  //       oldValue: selectedTask.assigneeId,
                  //       newValue: e.swimlaneId,
                  //       actionName: TASK_ACTIVITY_LOG_ACTIONS.STATUS_CHANGED,
                  //     },
                  //   })
                  // );
                  await dispatch(
                    updateSchedule({ key: "isGoalEdited", value: true })
                  );
                  // dispatch(getTaskActivityLog({ goalId: subtaskId }));
                  if (e.statusId == 3) {
                    dispatch(
                      updateProgress({
                        projectId,
                      })
                    );
                  }
                }
                queryClient.invalidateQueries(
                  ["goalsBySprint", projectId, taskDetails.sprintId],
                  {
                    refetchInactive: true,
                  }
                );
              }}
              statusId={taskDetails.statusId}
              task={taskDetails}
            />
            {subtaskId !== "new" ? (
              <Dropdown
                dropdownRender={(menu) => (
                  <div className="w-[200px]">{menu}</div>
                )}
                trigger={["click"]}
                menu={{ items: groupItems, onClick }}
              >
                <button>
                  <DotsVerticalIcon className="text-gray-900" />
                </button>
              </Dropdown>
            ) : null}
          </div>

          <RowLayout customLeft="Assignee" className="mt-5 mb-5">
            <UserSelect
              disabled={
                !(hasEditAccess || parentGoal?.collaborators.includes(user.id))
              }
              placeholder="Select Assignee"
              type="assignee"
              task={taskDetails}
              setTask={setTaskDetails}
              onEdit={async (id) => {
                if (subtaskId !== "new") {
                  setEditedTaskDetails({
                    ...editedTaskDetails,
                    assigneeId: id,
                  });
                  // await dispatch(
                  //   updateGoal({
                  //     assigneeId: id,
                  //     goalId: subtaskId,
                  //     action: {
                  //       oldValue: selectedTask.assigneeId,
                  //       newValue: id,
                  //       actionName: TASK_ACTIVITY_LOG_ACTIONS.ASSIGNEE_CHANGED,
                  //     },
                  //   })
                  // );
                  await dispatch(
                    updateSchedule({ key: "isGoalEdited", value: true })
                  );

                  // dispatch(getSubtaskDetails({ goalId: subtaskId }));

                  // dispatch(getTaskActivityLog({ goalId: subtaskId }));
                  // updateSprintGoals(taskDetails);

                  // await client.post("/notifications/create", {
                  //   notificationType: "32",
                  //   goalId: subtaskId,
                  //   allUsers: [{ userId: taskDetails.assigneeId }],
                  //   projectId,
                  //   meta: {
                  //     oldAssigneeId: selectedTask.assigneeId,
                  //     newAssigneeId: id,
                  //   },
                  // });
                }
                const sprintId = parseInt(taskDetails.sprintId, 10);
                queryClient.resetQueries(
                  ["goalsBySprint", projectId, sprintId],
                  { inactive: true }
                );
              }}
            />
          </RowLayout>

          <>
            <RowLayout customLeft="Priority" className=" mb-5">
              <PrioritySelect
                disabled={
                  !(
                    hasEditAccess || parentGoal?.collaborators.includes(user.id)
                  )
                }
                task={taskDetails}
                setTask={async (e) => {
                  setTaskDetails({ ...taskDetails, priorityId: e });
                  if (subtaskId !== "new") {
                    setEditedTaskDetails({
                      ...editedTaskDetails,
                      priorityId: e,
                    });
                    // await dispatch(
                    //   updateGoal({
                    //     priorityId: e,
                    //     goalId: subtaskId,
                    //     action: {
                    //       oldValue: selectedTask.priorityId,
                    //       newValue: e,
                    //       actionName: TASK_ACTIVITY_LOG_ACTIONS.PRIORITY_CHANGE,
                    //     },
                    //   })
                    // );
                    // await dispatch(
                    //   updateSchedule({ key: "isGoalEdited", value: true })
                    // );
                    // dispatch(getTaskActivityLog({ goalId: subtaskId }));
                  }
                  // updateSprintGoals(taskDetails);
                  const sprintId = parseInt(taskDetails.sprintId, 10);
                  queryClient.resetQueries(
                    ["goalsBySprint", projectId, sprintId],
                    { inactive: true }
                  );
                }}
              />
            </RowLayout>
            <RowLayout customLeft="Parent Task" className=" mb-8">
              <ParentTaskSelect
                disabled={false}
                subTask={taskDetails}
                setSubTask={async (e) => {
                  setTaskDetails({ ...taskDetails, parentGoalId: e });
                  if (subtaskId !== "new") {
                    setEditedTaskDetails({
                      ...editedTaskDetails,
                      parentGoalId: e,
                    });
                    // await dispatch(
                    //   updateGoal({
                    //     parentGoalId: e,
                    //     goalId: taskDetails.id,
                    //   })
                    // );

                    // dispatch(getTaskActivityLog({ goalId: subtaskId }));
                  }
                }}
              />
            </RowLayout>
          </>
          <div className="out-500-14 text-black">Time log</div>

          <RowLayout
            customLeft={
              <div className="flex items-center gap-x-1">
                <span>Original estimate</span>{" "}
                <InfoByFrosty
                  title="Original estimate"
                  content={
                    <div className="ml-12">
                      <p className="out-500-14 text-gray-500">0w 0d 00h 00m</p>
                      <p className="out-300-14  pt-2 text-gray-500">
                        w = weeks
                      </p>
                      <p className="out-300-14  pt-2 text-gray-500">d = days</p>
                      <p className="out-300-14  pt-2 text-gray-500">
                        h = hours
                      </p>
                      <p className="out-300-14  pt-2 text-gray-500">
                        m = minutes
                      </p>
                    </div>
                  }
                />
              </div>
            }
            className="mt-4 mb-5"
          >
            <TimeInput
              className=""
              disabled={
                !(hasEditAccess || parentGoal?.collaborators.includes(user.id))
              }
              value={taskDetails.estimatedTime}
              onChange={(e) =>
                setTaskDetails({ ...taskDetails, estimatedTime: e })
              }
              onOk={async (newTime: string) => {
                if (subtaskId !== "new") {
                  setEditedTaskDetails({
                    ...editedTaskDetails,

                    estimatedTime: newTime,
                  });
                  // await dispatch(
                  //   updateGoal({
                  //     estimatedTime: newTime,
                  //     goalId: subtaskId,
                  //     action: {
                  //       oldValue: selectedTask.estimatedTime,
                  //       newValue: newTime,
                  //       actionName: TASK_ACTIVITY_LOG_ACTIONS.ESTIMATE_CHANGE,
                  //     },
                  //   })
                  // );
                  // await dispatch(
                  //   updateSchedule({ key: "isGoalEdited", value: true })
                  // );
                  // dispatch(getTaskActivityLog({ goalId: subtaskId }));
                }
              }}
            />
          </RowLayout>

          <RowLayout
            customLeft={
              <div className="flex items-center gap-x-1">
                <span>Log more time</span>{" "}
                <InfoByFrosty
                  title="Log more time"
                  content={
                    <div className="ml-12">
                      <p className="out-500-14 text-gray-500">0w 0d 00h 00m</p>
                      <p className="out-300-14  pt-2 text-gray-500">
                        w = weeks
                      </p>
                      <p className="out-300-14  pt-2 text-gray-500">d = days</p>
                      <p className="out-300-14  pt-2 text-gray-500">
                        h = hours
                      </p>
                      <p className="out-300-14  pt-2 text-gray-500">
                        m = minutes
                      </p>
                    </div>
                  }
                />
              </div>
            }
            className="mt-4 mb-8"
          >
            {subtaskId === "new" ? (
              <Controller
                name="timeLogged"
                control={control}
                // rules={{ required: "Please enter a title before submitting" }}
                render={({ field, formState }) => (
                  <TimeInput
                    className=""
                    disabled={
                      taskDetails.timeLogged === ""
                        ? !(
                            LOG_TIME_ADD ||
                            parentGoal?.collaborators.includes(user.id)
                          )
                        : !(
                            LOG_TIME_EDIT ||
                            parentGoal?.collaborators.includes(user.id)
                          )
                    }
                    value={
                      taskDetails.timeLogged || getValues("timeLogged") || ""
                    }
                    addNewTimeToPreviousTime
                    onChange={(e) =>
                      setTaskDetails({ ...taskDetails, timeLogged: e })
                    }
                    onOk={async (
                      newTime: string,
                      totalTime: string,
                      value: string
                    ) => {
                      if (subtaskId !== "new") {
                        setEditedTaskDetails({
                          ...editedTaskDetails,

                          timeLogged: newTime,
                        });
                        // await dispatch(
                        //   updateGoal({
                        //     timeLogged: newTime,
                        //     goalId: subtaskId,
                        //     action: {
                        //       oldValue: taskDetails.timeLogged,
                        //       newValue: totalTime,
                        //       actionName:
                        //         TASK_ACTIVITY_LOG_ACTIONS.TIMELOG_CHANGE,
                        //     },
                        //   })
                        // );
                        // await dispatch(
                        //   updateSchedule({ key: "isGoalEdited", value: true })
                        // );
                        // dispatch(getSubtaskDetails({ goalId: subtaskId }));

                        // dispatch(getTaskActivityLog({ goalId: subtaskId }));
                      }
                      setParentTaskTime(value);
                    }}
                  />
                )}
              />
            ) : (
              <TimeInput
                className=""
                disabled={
                  taskDetails.timeLogged === ""
                    ? !(
                        LOG_TIME_ADD ||
                        parentGoal?.collaborators.includes(user.id)
                      )
                    : !(
                        LOG_TIME_EDIT ||
                        parentGoal?.collaborators.includes(user.id)
                      )
                }
                value={taskDetails.timeLogged || ""}
                addNewTimeToPreviousTime
                onChange={(e) =>
                  setTaskDetails({ ...taskDetails, timeLogged: e })
                }
                onOk={async (newTime: string, totalTime: string) => {
                  if (subtaskId !== "new") {
                    setEditedTaskDetails({
                      ...editedTaskDetails,

                      timeLogged: newTime,
                    });
                    setParentTaskTime(totalTime);

                    // await dispatch(
                    //   updateGoal({
                    //     timeLogged: newTime,
                    //     goalId: subtaskId,
                    //     action: {
                    //       oldValue: taskDetails.timeLogged,
                    //       newValue: totalTime,
                    //       actionName: TASK_ACTIVITY_LOG_ACTIONS.TIMELOG_CHANGE,
                    //     },
                    //   })
                    // );
                    // await dispatch(
                    //   updateSchedule({ key: "isGoalEdited", value: true })
                    // );
                    // dispatch(getSubtaskDetails({ goalId: subtaskId }));

                    // dispatch(getTaskActivityLog({ goalId: subtaskId }));
                  }
                }}
              />
            )}
          </RowLayout>

          <div className="out-500-14 text-black">More details</div>
          <RowLayout
            customLeft={
              <div className="flex items-center gap-x-1">
                <span>Release version</span>{" "}
                <InfoByFrosty
                  title="Release version"
                  content={
                    "Release versions are important for identifying and tracking different versions of the software. They help with testing, debugging, troubleshooting, and enable users to understand which version of the software they are using, along with its features and improvements."
                  }
                />
              </div>
            }
            className="mt-4 mb-8"
          >
            <VersionSelect
              task={taskDetails}
              disabled={
                !(hasEditAccess || parentGoal?.collaborators.includes(user.id))
              }
              setTask={async (e) => {
                setTaskDetails({ ...taskDetails, releaseVersionId: e });
                if (subtaskId !== "new") {
                  setEditedTaskDetails({
                    ...editedTaskDetails,

                    releaseVersionId: e,
                  });
                  // await dispatch(
                  //   updateGoal({
                  //     releaseVersionId: e,
                  //     goalId: taskId,
                  //     action: {
                  //       oldValue: selectedTask.releaseVersionId,
                  //       newValue: e,
                  //       actionName:
                  //         TASK_ACTIVITY_LOG_ACTIONS.RELEASE_VERSION_CHANGE,
                  //     },
                  //   })
                  // );
                  // await dispatch(
                  //   updateSchedule({ key: "isGoalEdited", value: true })
                  // );
                  // dispatch(getTaskActivityLog({ goalId: subtaskId }));
                }
                const sprintId = parseInt(taskDetails.sprintId, 10);
                queryClient.invalidateQueries(
                  ["goalsBySprint", projectId, sprintId],
                  {
                    refetchInactive: true,
                  }
                );
              }}
            />
          </RowLayout>
          <RowLayout customLeft="Created on" className=" mb-5">
            <div className="flex px-[14px]">
              <p className="out-300-14 text-gray-400  ">
                {taskDetails?.createdAt
                  ? dayjs(taskDetails?.createdAt).format("DD/MM/YYYY")
                  : dayjs().format("DD/MM/YYYY")}
              </p>
            </div>
          </RowLayout>

          {completedOn && (
            <RowLayout customLeft="Completed on" className="mt-4 mb-5">
              <div className="flex px-[14px]">
                <p className="out-300-14 text-gray-400  ">{completedOn}</p>
              </div>
            </RowLayout>
          )}
        </div>
      </div>

      <NewLabelModal
        visible={newLabelModal}
        onClose={() => dispatch(resetSchedule(["newLabelModal"]))}
        isMyBoard
      />

      <ManageLabelsModal
        visible={manageLabelModal}
        onClose={() => dispatch(resetSchedule(["manageLabelModal"]))}
      />
      <DeleteLabelModal
        visible={deleteLabelModal.visible}
        onClose={() => dispatch(resetSchedule(["deleteLabelModal"]))}
      />
      <NewReleaseVersionModal
        visible={newReleaseVersionModal}
        onClose={() => dispatch(resetSchedule(["newReleaseVersionModal"]))}
      />
      <DeleteTaskModal
        visible={taskDeleteModal}
        selectedTasks={selectedTasks}
        onClose={() => setTaskDeleteModal(false)}
      />

      <FilePreviweModal
        visible={filePreview.visible}
        page="task"
        onClose={() => dispatch(resetConversations(["filePreview"]))}
      />
      <DiscardEditedGoalModal
        onClose={() => setDiscardModal(false)}
        onDiscard={() => {
          setEditedTaskDetails(false);
          setDiscardModal(false);
          onDiscardTask();
        }}
        visible={discardModal}
      />
    </ScheduleLayout>
  );
};

export default ScheduleSubtaskScreen;
